import ExternalLink from '../atoms/ExternalLink';
import Heading from '../atoms/Heading';
import LinkButton from '../atoms/LinkButton';

/**
 * ソニーアカウントの概要説明と登録・変更導線をまとめて表示するセクション。
 * 回線契約とは別軸の共通 ID なので、用途説明を添えてから設定画面へ誘導している。
 */
const SonyAccountInfo = () => {
  return (
    <div className='m-box-02'>
      <div className='m-box-02__inner'>
        <Heading as='h2' icon='gear'>
          ソニーアカウント
        </Heading>
        <div>
          <ul className='m-list-notice'>
            <li className='m-list-notice__item'>
              ソニーグループの各種サービスでお使いいただける、ソニーグループ各社共通のアカウントです。
              {/* 共通 ID の位置付けを理解したうえで設定画面へ進めるよう、補足説明への外部導線を併記する。 */}
              <ExternalLink href='https://acm.account.sony.com/linking-account#page-top'>
                アカウント共通化について詳しく
              </ExternalLink>
            </li>
          </ul>
        </div>
        <div className='m-button align-center'>
          {/* 説明の直後に設定導線を置き、アカウント連携の学習コストを最小化する。 */}
          <LinkButton variant='secondary' href='/contract/sony_account'>
            ソニーアカウントサービスの登録・変更
          </LinkButton>
        </div>
      </div>
    </div>
  );
};

export default SonyAccountInfo;
